import { useCallback, useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { BiLogoTelegram } from "react-icons/bi";
import { FaTelegram } from "react-icons/fa";
import TelegramLoginButton, { TelegramUser } from "telegram-login-button";
import useGetAgentName from "../../../hook/useGetAgentName";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import { actionTelegramLogin } from "../../../api/postApi";
import { MD5 } from "crypto-js";
import useCookiesAgentName from "./useCookiesAgentName";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { loading, loadingDestroy } from "../../../redux/action/action";

const telegramLink = "tglogin";

const TelegramLogin = ({ setButtonLoading, buttonLoading }) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [saveData, setSaveData] = useState({
    first_name: "",
    hash: "",
    id: null,
    last_name: "",
  });

  const agentName = useGetAgentName();

  const cookiesFromAgent = useCookiesAgentName();

  const handleLoginTelegram = ({ first_name, hash, id, last_name }) => {
    const randomNumber = Math.random().toString().slice(2, 14);
    dispatch(loading());
    setButtonLoading(true);

    actionTelegramLogin({
      first_name,
      hash,
      telegramId: id,
      last_name,
      unlimit_code: "",
      invite: cookiesFromAgent,
      s_auth: randomNumber,
      r_auth: MD5(`Tgs${randomNumber}mov9191Login`).toString(),
    })
      .then((data) => {
        if (data.message === "Sign up success.") {
          actionTelegramLogin({
            first_name,
            hash,
            telegramId: id,
            last_name,
            unlimit_code: "",
            invite: cookiesFromAgent,
            s_auth: randomNumber,
            r_auth: MD5(`Tgs${randomNumber}mov9191Login`).toString(),
          }).then((data) => {
            if (Cookies.get("token")) {
              Cookies.remove("token");
            }
            Cookies.set("token", data.token, { expires: 3 });
            dispatch({ type: "INITIALIZE_API", navigate: navigate });
            navigate("/casino");
          });
        } else {
          if (Cookies.get("token")) {
            Cookies.remove("token");
          }
          Cookies.set("token", data.token, { expires: 3 });
          dispatch({ type: "INITIALIZE_API", navigate: navigate });
          navigate("/casino");
        }
      })
      .catch((err) => {})
      .finally(() => {
        setButtonLoading(false);
        dispatch(loadingDestroy());
      });
  };

  return (
    <>
      <TelegramLoginButton
        className={`flex w-full items-center justify-center bg-[#53A9EB] h-[45.5px] rounded-[5px] !mt-[15px] telegram-button`}
        botName="a911wincobot"
        cornerRadius="5"
        usePic={false}
        dataOnauth={(user: TelegramUser) => {
          const { first_name, hash, id, last_name } = user;
          handleLoginTelegram({ first_name, hash, id, last_name });
        }}
      />
    </>
  );
};

export default TelegramLogin;
